import { connect } from 'react-redux';
import React, { Component } from "react";
// react component for creating dynamic tables
import ReactTable from "react-table";
import { Card, CardBody, CardHeader, CardTitle, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { PanelHeader } from "components";
import Button from "components/CustomButton/CustomButton.jsx";
import { history } from 'helpers';
import { Link } from 'react-router-dom';
import SweetAlert from "react-bootstrap-sweetalert";
import { projectConstants } from "../../constants";
import { userActions } from 'actions';
import { permissions } from '../../helpers';
import UsersTable from './UsersTable';
import User from '../../entities/User';
import { utils } from '../../helpers/utils';
import ButtonWithTooltip from '../../components/Custom/ButtonWithTooltip';
import { authentication } from '../../reducers/authentication.reducer';
import { withTranslation } from 'react-i18next';

class Users extends Component {

  constructor(props) {
    super(props);
     
    this.roles = JSON.parse(localStorage.getItem('userroles'));
    this.rolesIndex = utils.doIndex(this.roles, 'id');

    // this.usersOptions = [];
    // let users = JSON.parse(localStorage.getItem('users'));
    // if (users) {
    //   users.map(
    //     (user) => {
    //       this.usersOptions.push({
    //         value: user.id, label: user.name + " " + user.surname
    //       });
    //     }
    //   );
    // }

    this.state = {
      alert: null
    }

  }

  deleteConfirm(id) {
      const { t } = this.props;
      this.setState({
        alert: (
          <SweetAlert
            warning
            customClass="custom-sweet-alert"
            style={{ display: "block" }}
            title={t("Cancellazione utente")}
            onConfirm={() => {
              const { dispatch } = this.props;
              if (id) {
                dispatch(userActions.delete(id));
                this.setState({
                  alert: null
                });  
              }
            }}
            onCancel={() => { 
              this.setState({
                alert: null
              });
            }}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText={t("SI")}
            cancelBtnText={t("NO")}
            showCancel
          >
            {t("Sei sicuro?")}
          </SweetAlert>
        )
      });
  }


  render() {

    const { t, users } = this.props;

    let data = [];

    if (users && users.items) {

      data = users.items.map((item, key) => {

        const role = this.roles[this.rolesIndex[item.userRoleId]];

        return {
          id: key,
          email: item.email,
          name: item.name,
          surname: item.surname,
          userRoleId: item.userRoleId,
          isActive: item.isActive,
          actions: (
            <div className="actions-right">
              <Link to={"/users/edit/" + item.id} >
                <ButtonWithTooltip
                  id={"editUser_" + item.id}
                  color="warning"
                  size="sm"
                  round
                  icon
                  tooltipText={t("Modifica")}
                >
                  <i className="fa fa-edit" />
                </ButtonWithTooltip>
              </Link>
              {" "}
              <ButtonWithTooltip
                id={"deleteConfirmUser_" + item.id}
                onClick={() => { this.deleteConfirm(item.id); }}
                color="danger"
                size="sm"
                round
                icon
                tooltipText={t("Elimina")}
              >
                <i className="fa fa-times" />
              </ButtonWithTooltip>
              {" "}
            </div>
          )
        };
      })
    }

 

    return (
      <div>
        {this.state.alert}
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col xs={12} md={12}>
              <UsersTable
                users={users}
                data={data}
                dispatch={this.props.dispatch}
                columns={[
                  {
                      Header: t("Email"),
                      accessor: "email",
                      Filter: ({filter, onChange}) => (
                        <input
                          onChange={event => onChange(event.target.value)}
                          value={filter ? filter.value : ''}
                          placeholder={t("Search...")}
                          style={{
                            width: '100%'
                          }}
                        />
                      ),
                      filterable: !this.props.users.loading
                  },
                  {
                      Header: t("Nome"),
                      accessor: "name",
                      Filter: ({filter, onChange}) => (
                        <input
                          onChange={event => onChange(event.target.value)}
                          value={filter ? filter.value : ''}
                          placeholder={t("Search...")}
                          style={{
                            width: '100%'
                          }}
                        />
                      )
                  },
                  {
                      Header: t("Cognome"),
                      accessor: "surname",
                      Filter: ({filter, onChange}) => (
                        <input
                          onChange={event => onChange(event.target.value)}
                          value={filter ? filter.value : ''}
                          placeholder={t("Search...")}
                          style={{
                            width: '100%'
                          }}
                        />
                      )
                  },
                  {
                      Header: t("Ruolo"),
                      accessor: "userRoleId",
                      Cell: row => ( this.roles[this.rolesIndex[row.value]].role ),
                      Filter: ({ filter, onChange }) =>
                      <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%" }}
                        value={filter ? filter.value : ""}
                      >
                        <option key={0} value="">-</option>
                        { this.roles.map( role => <option key={role.id} value={role.id}>{role.role}</option>) }
                      </select>                      
                      
                  },
                  {
                    Header: t("Attivo"),
                    accessor: "isActive",
                    Cell: row => ( row.value ? <div align="center"><i className={"now-ui-icons ui-1_check"} /></div>: ""  ),
                    Filter: ({ filter, onChange }) =>
                    <select
                      onChange={event => onChange(event.target.value)}
                      style={{ width: "100%" }}
                      value={filter ? filter.value : ""}
                    >
                      <option key={0} value="">-</option>
                      <option key={1} value={true}>{t("SI")}</option>
                      <option key={2} value={false}>{t("NO")}</option>
                    </select>                      
                    
                },

                  {
                      Header: t("Azioni"),
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                      resizable: false
                  }
              ]}

              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication } = state;
  return {
    users,
    loggedinUser: authentication.user
  };
}

const connectedUsers = withTranslation()(connect(mapStateToProps)(Users));
export { connectedUsers as Users }; 


// WEBPACK FOOTER //
// ./src/views/Users/Users.jsx